export default {
  collectionSchema: "/CollectionSchema.ts" as const,
  previousCollectionSchema: "/PreviousCollectionSchema.ts" as const,
  nextCollectionSchema: "/NextCollectionSchema.ts" as const,
};
